import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';
import type { AxiosRequestConfig } from 'axios';
import type {
  HIEvidenceRequest,
  HIEvidenceResponse,
} from '../model/hi-evidence';

const baseURL = '/api/monitoring/v4';

export class HIEvidenceAPI {
  static list(payload: HIEvidenceRequest, options?: AxiosRequestConfig) {
    return monitoringInstance.post<HIEvidenceResponse>(
      '/hi/evidence',
      payload,
      {
        ...options,
        baseURL,
      },
    );
  }

  static getMediaUrl(mediaId: string) {
    return `${baseURL}/media/${encodeURIComponent(mediaId)}`;
  }
}